import React from 'react';

interface ViewModeToggleProps {
  viewMode: 'list' | 'calendar';
  onViewModeChange: (mode: 'list' | 'calendar') => void;
}

const ViewModeToggle: React.FC<ViewModeToggleProps> = ({ viewMode, onViewModeChange }) => {
  return (
    <div className="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-full p-1 flex">
      <button 
        onClick={() => onViewModeChange('list')} 
        className={`px-6 py-2 rounded-full text-sm font-medium transition-colors ${
          viewMode === 'list' ? 'bg-white text-black' : 'text-gray-400 hover:text-white'
        }`}
      >
        List
      </button>
      <button 
        onClick={() => onViewModeChange('calendar')} 
        className={`px-6 py-2 rounded-full text-sm font-medium transition-colors ${
          viewMode === 'calendar' ? 'bg-white text-black' : 'text-gray-400 hover:text-white'
        }`}
      >
        Calendar
      </button>
    </div>
  );
};

export default ViewModeToggle;
